import { render } from "./User_manage.vue?vue&type=template&id=770208f8"
import script from "./User_manage.vue?vue&type=script&lang=js"
export * from "./User_manage.vue?vue&type=script&lang=js"
script.render = render

export default script